export default function HomeSetView(data) {
  this.rest.post("home/setview", { roles: data.selectedRoles, users: data.selectedUsers }, function(data) {});
}
